/** Whether the floating bottom nav should render for this route and shell. */
export function shouldShowMobileNav(pathname: string, mobileAppShell: boolean): boolean {
  if (!mobileAppShell) return false;
  if (pathname.startsWith('/admin')) return false;
  if (['/login', '/register', '/invite', '/forgot-password'].includes(pathname)) return false;
  if (pathname.startsWith('/live/')) return false;
  if (pathname.startsWith('/scoreboard/') || pathname.startsWith('/overlay/')) return false;
  return true;
}
